import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LiquidacaoService } from 'administrativo-lib';
import { EddyAutoComplete, Favorecido, FavorecidoService, GlobalService, Login, OrgaoAssinaturaService } from 'eddydata-lib';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotaLiquidacao } from '../../relatorio/liquidacao/nota-liquidacao';
import { warning } from 'toastr';

@Component({
  selector: 'app-nota-liquidacao-dlg',
  templateUrl: './nota-liquidacao-dlg.component.html'
})
export class NotaLiquidacaoDlgComponent implements OnInit, OnDestroy {

  protected datepipe: DatePipe;
  public ptBR: any;
  public selectedOrdem: string;
  public selectedModelo: string;
  public selectedOpt: string;
  public selectNaoImpresso: boolean;
  public selectUsuario: boolean;
  public selectFornecedor: boolean;
  public marcarComoImpresso: boolean;
  public dataInicio: Date;
  public dataFinal: Date;
  public numeroInicio: number;
  public numeroFinal: number;
  public selectAnulado: boolean;
  public favorecido: Favorecido;

  public favorecidoAutoComplete: EddyAutoComplete<Favorecido>;

  protected unsubscribe: Subject<void> = new Subject();

  public imaskNumero = {
    mask: Number,
    scale: 0,
    signed: false
  };

  @Input() login: Login;
  @Input() empenhosSelecionados: any[];

  constructor(
    protected confirmationService: ConfirmationService,
    protected messageService: MessageService,
    private globalService: GlobalService,
    protected assinaturaService: OrgaoAssinaturaService,
    private liquidacaoService: LiquidacaoService,
    private favorecidoService: FavorecidoService
  ) { }

  ngOnInit() {
    this.ptBR = this.globalService.obterDataBR();
    this.datepipe = new DatePipe('pt');
    this.selectedOrdem = 'ord1';
    this.selectedOpt = 'opt1';
    this.selectedModelo = '1'
    this.selectNaoImpresso = true;
    this.selectUsuario = true;
    this.dataInicio = new Date();
    this.dataFinal = new Date();

    this.favorecidoAutoComplete = new EddyAutoComplete(null, this.favorecidoService,
      'id', ['nome'], { 'cidade.id': this.login.cidade.id, relations: 'tipo,contas.banco,contas.orgao', orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  imprimir() {
    if (this.selectNaoImpresso) {
      this.confirmationService.confirm({
        message: 'Deseja marcar as liquidações como impressas ?',
        acceptLabel: "Sim",
        rejectLabel: "Não",
        header: 'Confirmação',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.marcarComoImpresso = true;
          this.gerarImpressaoLiquidacao();
        },
        reject: () => {
          this.marcarComoImpresso = false;
          this.gerarImpressaoLiquidacao();
        }
      });
    } else {
      this.marcarComoImpresso = false;
      this.gerarImpressaoLiquidacao();
    }
  }

  gerarImpressaoLiquidacao() {
    const parametros = {};

    let relations = '';
    relations += 'empenho,empenho.contrato,empenho.licitacao,empenho.modalidade,empenho.subelemento,empenho.compra,empenho.compra.rcms,';
    relations += 'empenho.favorecido.contas.banco,empenho.favorecido.contas.orgao,empenho.favorecido.tipo,empenho.ficha,empenho.ficha.executora.unidade,empenho.ficha.despesa,empenho.ficha.funcao,';
    relations += 'empenho.ficha.acao,empenho.ficha.aplicacao,empenho.ficha.recurso,empenho.ficha.aplicacao_variavel,retencoes.ficha';

    if (this.selectedOpt === 'opt1') {
      if (+this.dataFinal < +this.dataInicio) {
        warning('Data final do empenho está maior que a inicial');
        return;
      }
      if (!this.dataInicio || !this.dataFinal || +this.dataFinal === 0 || +this.dataInicio === 0) {
        warning('Informe a data inicial e final para imprimir');
        return;
      }
    } else if (this.selectedOpt === 'opt2') {
      if (+this.numeroFinal < +this.numeroInicio) {
        warning('Número final do empenho está maior que o inicial');
        return;
      }
      if (!this.numeroInicio || !this.numeroFinal || +this.numeroFinal === 0 || +this.numeroInicio === 0) {
        warning('Informe o número inicial e final para imprimir');
        return;
      }
    } else {
      if (this.empenhosSelecionados.length === 0 || !this.empenhosSelecionados) {
        warning('Selecione ao menos uma liquidação para imprimir')
        return;
      }
    }

    parametros['relations'] = relations;
    parametros['exercicio_id'] = this.login.exercicio.id;
    parametros['orgao_id'] = this.login.orgao.id;
    if (this.selectedOrdem === 'ord1') {
      parametros['orderBy'] = 'empenho.numero$ASC,parcela$ASC';
    } else if (this.selectedOrdem === 'ord2') {
      parametros['orderBy'] = 'empenho.favorecido.nome$ASC';
    } else {
      parametros['orderBy'] = 'data_cadastro$ASC';
    }

    if (this.selectedOpt === 'opt1') {
      parametros['data_liquidacao$ge'] = this.datepipe.transform(this.dataInicio, 'yyyy-MM-dd');
      parametros['data_liquidacao$le'] = this.datepipe.transform(this.dataFinal, 'yyyy-MM-dd');
    } else if (this.selectedOpt === 'opt2') {
      parametros['empenho.numero$ge'] = +this.numeroInicio;
      parametros['empenho.numero$le'] = +this.numeroFinal;
    } else {
      parametros['empenho.numero$in'] = this.empenhosSelecionados;
    }
    if (this.selectNaoImpresso) {
      parametros['impresso'] = !this.selectNaoImpresso;
    }
    if (this.selectUsuario) {
      parametros['usuario_cadastro_id'] = this.login.usuario.id;
    }
    if (this.selectFornecedor) {
      parametros['empenho.favorecido.nome$like'] = this.favorecido.nome;
    }
    if (this.selectAnulado) {
      parametros['anulacao'] = true;
    } else {
      parametros['anulacao'] = false;
    }
    parametros['notaLiquidacao'] = true;

    this.liquidacaoService
      .extendido(1, -1, parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(lista => {
        new NotaLiquidacao(this.assinaturaService).imprimir(lista.content, this.login, this.selectedModelo);
        if (this.marcarComoImpresso && lista.content.length > 0) {
          this.liquidacaoService.marcarComoImpresso(parametros).subscribe(() => {
          });
        }
      },
        (e) => this.messageService.add(
          { severity: 'error', summary: 'Atenção!', detail: e.error && e.error.payload ? e.error.payload : e }
        )
      );
  }
}
